export type LocalDraft = {
    name: string;
    transportModeId: number | null;
    distanceKm: string;
    originCountryCode: string;
    destinationCountryCode: string;
    isRefrigerated: boolean;
    originLatitude: number | null;
    originLongitude: number | null;
    originLabel: string;
    destinationLatitude: number | null;
    destinationLongitude: number | null;
    destinationLabel: string;
};

export const blankDraft: LocalDraft = {
    name: "",
    transportModeId: null,
    distanceKm: "",
    originCountryCode: "",
    destinationCountryCode: "",
    isRefrigerated: false,
    originLatitude: null,
    originLongitude: null,
    originLabel: "",
    destinationLatitude: null,
    destinationLongitude: null,
    destinationLabel: "",
};

export const isRefrigeratedTransportCode = (code?: string | null) => code?.includes("reefer") ?? false;

export const formatDistanceKm = (distanceKm: number) => (Math.round(distanceKm * 10) / 10).toString();
